module.exports = __webpack_public_path__ + "img/PL09117.cdf75264.png";